import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { projectUrls } from "../../URL/ApplicationUrls";
import { deleteSuccessMessage } from "../../Messages/successMessages";
import { deleteFailedMessage } from "../../Messages/errorMessages";

export function useDeleteProject() {
  const navigate = useNavigate();
  return async function deleteProjectWithId(projectId: number | string | undefined) {
    const response = await axios.delete(projectUrls.projectWithId(projectId).apiUrl);
    if (response.status === 200) {
      toast.success(deleteSuccessMessage(projectId, "Project"));
      navigate(projectUrls.base.uiPath);
    } else toast.error(deleteFailedMessage(projectId, "Project"));
  };
}
